/** Phase 6.3: scene images and ambient music moods (shared by server, bot and web). */
export const IMAGE_KINDS = ["scene", "portrait", "map"];
/** Ambient music moods (the web plays them with generated sound; nothing is downloaded). */
export const SCENE_MOODS = ["calm", "tavern", "town", "forest", "dungeon", "cave", "mystery", "battle", "boss", "storm", "sea", "sad", "triumph", "silence"];
export const MOOD_LABELS = {
    calm: "Calm", tavern: "Tavern", town: "Town", forest: "Forest", dungeon: "Dungeon", cave: "Cave", mystery: "Mystery",
    battle: "Battle", boss: "Boss fight", storm: "Storm", sea: "At sea", sad: "Sorrow", triumph: "Triumph", silence: "Silence",
};
export const isSceneMood = (v) => typeof v === "string" && SCENE_MOODS.includes(v);
/** Style wording added to every image prompt (keeps the look consistent and table-safe). */
export function imagePrompt(kind, description, mature) {
    const d = description.replace(/\s+/g, " ").trim().slice(0, 900);
    const style = {
        scene: "Epic fantasy illustration, painterly digital art, dramatic lighting, wide establishing shot",
        portrait: "Fantasy character portrait, head and shoulders, painterly digital art, simple dark background",
        map: "Top-down fantasy map of the area, hand-drawn parchment style, clear layout, no text or labels",
    }[kind];
    return `${style}. ${d}. No text, no watermark${mature ? "" : ", family-friendly, no gore"}.`;
}
//# sourceMappingURL=media.js.map